import { IFilterComplete } from "../../filter-complete/filter-complete";

export class DocumentTypeFilter implements IFilterComplete {
  public Name: string;
  public Id: number;
  public RequiredNumber: boolean;
}
